module.exports = __webpack_public_path__ + "img/lighting-studio_en.0826bbe.jpg";